import { useState, useEffect, useRef } from "react";

import "./DashboardEditorGrid.css";
import '/src/components/UI/Button/IconButton/IconButton.css'
import dashboardService from '../../../services/dashboardService';
import DashboardCell from "../DashboardCell"
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
function DashboardEditorGrid({ data, structure, postbackAction, access }) {
    const ref = useRef()
    const toast = useToastDispatchContext();
    const { updateCellValueGrid, updateDashboardVariableShared } = dashboardService;
    const [errorMessage, setErrorMessage] = useState([]);

    /**
     * Modify the error for the input cells in grid
     **/
    const setErrorInput = (parents, clear) => {
        if (clear == false) {    
            if (errorMessage.filter(error => error.parents.column == parents.column && error.parents.row.index == parents.row.index).length == 0) {  /// on itere sur les erreur existantes,si ca existe deja, on passe, si ca existe pas, on rajoute
                setErrorMessage([...errorMessage, { parents }]);
            }
        }
        else {
            let res = [];
            errorMessage.map(error => (error.parents.column == parents.column && error.parents.row.index == parents.row.index) || res.push(error));
            setErrorMessage(res);
        }
    }

    /**
     * Modify the value of the cell in the grid, not the structure
     */
    const modifyValue = async (index, value, active) => {
        let dataToSend = { index: index, value: value, block_id: data.id, active: active, dashboard_channel_id : data.dashboard_channel.id } // dashboard channel id for cell grid
        console.log(data)
        const [response, errors] = data.origin == 0 ? await updateDashboardVariableShared(data.variables[0].id,dataToSend) : await updateCellValueGrid(index,dataToSend)
        if (errors != null) {
            console.log(errors)
            return;
        }
        toast.success('Variable\'s value changed', 'The value of a cell has been changed !');

    }

    /**
     * Retrieve the value of a cell in grid in shared dashboard, with it index 
     */
    const getCellShared = (index) => {
        let shared_values = data.shared_values_variables != null ? JSON.parse(data.shared_values_variables) : null
        if (shared_values == null) return;
        const value = shared_values.find(val => val.dashboard_variable_id === data.variables[0].id).cells[index];
        return value;
    }

    return (
        <>
            <div ref={ref} className="gridDashboardEditor_main_container">
                {
                    data.grid.type_variable == 1 && errorMessage.length > 0 &&

                    <span className="containerError_input_dashboard_grid">

                        {data.grid.placeholder_format} :
                        {
                            errorMessage.map((cell, i) => {
                                console.log(cell)
                                return (
                                    <span className="errorInput_dashboard_grid_editor"> [{cell.parents.row.value}, {cell.parents.column}]</span>
                                )
                            })
                        }

                    </span>
                }

                <div className="dashboard_editor_grid_column">
                    <div className={"root_cellEditor" + (structure.columns.length > 0 ? "" : "single_rootEditor")} />
                    {
                        structure.columns.map((cell, i) => {
                            return (
                                <div key={i}>
                                    <DashboardCell data={cell} className={"dashboard_editor_column_cell dashboard_cell_Editor"} disabled={true}></DashboardCell>
                                </div>
                            )
                        })
                    }
                </div>
                <div className="rowsEditor">
                    {
                        structure.rows.map((row, i) => {
                            return (
                                <div key={i} style={{ display: "flex" }}>
                                    < DashboardCell data={row} className={"dashboard_editor_row_cell dashboard_cell_Editor"} disabled={true}></DashboardCell>
                                    {
                                        structure.cells?.map((cell, j) => {
                                            if (j > structure.columns.length - 1) return;
                                            j = j + i * structure.columns.length
                                            cell = data.origin == 0 ? getCellShared(j) : structure.cells[j];

                                            return (
                                                <div key={j} style={{ display: "flex" }}>
                                                    < DashboardCell access={access} data={{ cell: cell, index: j }} gridValues={data.grid} parents={{ row: row, column: structure.columns[j % structure.columns.length].value }} className={"dashboard_editor_row_cell dashboard_cell_Editor"} postbackAction={(index, value, active) => modifyValue(index, value)} modifyErrorInput={setErrorInput}></DashboardCell>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            )
                        })
                    }

                </div>
                {

                    data.grid.type_variable == 1 && errorMessage.length > 0 && ref.current?.clientHeight > 400 &&
                    <span className="containerError_input_dashboard_grid"> {data.grid.placeholder_format}  :
                        {
                            errorMessage.map((cell, i) => {
                                return (
                                    <span className="errorInput_dashboard_grid_editor">[{cell.parents.row.value}, {cell.parents.column}]</span>
                                )
                            })
                        }



                    </span>

                }
            </div>
        </>
    );
}

export default DashboardEditorGrid;